import { ReactComponent as WaitIcon } from 'src/mobile/assets/icons/wait.svg'
import { ReactComponent as CheckRightIcon } from 'src/mobile/assets/icons/booking-step-3.svg'
import { ReactComponent as CheckMarkIcon } from 'src/mobile/assets/icons/checkmark-circle-2.svg'
import { ReactComponent as AlertIcon } from 'src/mobile/assets/icons/alert-circle.svg'
import { ReactComponent as CloseIcon } from 'src/mobile/assets/icons/close-circle.svg'

export const DAY_SEGMENTS = ['options.day_segments.0', 'options.day_segments.1', 'options.day_segments.2']

export const MOBILE_HEADER_HEIGHT = 8.25

export const QUIZ_LIST = [
  {
    name: 'history',
    question: 'form.test_requisition_list.0',
  },
  {
    name: 'previous',
    question: 'form.test_requisition_list.1',
  },
  {
    name: 'current',
    question: 'form.test_requisition_list.2',
  },
  {
    name: 'smoker',
    question: 'form.test_requisition_list.3',
  },
]

export const QUIZ_ANSWER_OPTIONS = [
  { label: 'form.test_requisition_answer_list.0', value: '0' },
  { label: 'form.test_requisition_answer_list.1', value: '1' },
  { label: 'form.test_requisition_answer_list.2', value: '2' },
]

export const ORDER_STATUS_HEADER = {
  0: {
    label: 'glossary.order_status_list.0',
    bgColor: 'secondary',
    icon: <WaitIcon />,
  },
  1: {
    label: 'glossary.order_status_list.1',
    bgColor: 'primary',
    icon: <CheckMarkIcon />,
  },
  2: {
    label: 'glossary.order_status_list.2',
    bgColor: 'primary',
    icon: <AlertIcon />,
  },
  3: {
    label: 'glossary.order_status_list.3',
    bgColor: 'secondary',
    icon: <WaitIcon />,
  },
  4: {
    label: 'glossary.order_status_list.4',
    bgColor: 'primary',
    icon: <CheckRightIcon />,
  },
  5: {
    label: 'glossary.order_status_list.5',
    bgColor: 'primary',
    icon: <AlertIcon />,
  },
  6: {
    label: 'glossary.order_status_list.6',
    bgColor: 'secondary',
    icon: <CloseIcon />,
  },
  8: {
    label: 'glossary.order_status_list.6',
    bgColor: 'secondary',
    icon: <CloseIcon />,
  },
  7: {
    label: 'glossary.order_status_list.3',
    bgColor: 'secondary',
    icon: <WaitIcon />,
  },
}
